import { render } from "./video-item.vue?vue&type=template&id=7d9b1ba2&ts=true"
import script from "./video-item.vue?vue&type=script&lang=ts"
export * from "./video-item.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__